export default __webpack_public_path__ + "static/DSC_0181-b50216652b455ede8eff374b3e98ead3.jpg";